// extracted by mini-css-extract-plugin
export default {"Info":"Info_Info__lFeFa","Info__container":"Info_Info__container__ktWDg"};